import React from "react";
import { useSelector } from "react-redux";
import { getDate } from "utils/formatDate";
import { formatNumber } from "utils/currencyFormat";
import { BtnXoa } from "./ChucNang/Xoa/BtnXoa";
import { BtnChiTietPhieu } from "./ChucNang/ChiTietPhieu/BtnChiTietPhieu";
import { BtnInPhieuThuChiNgoaiLe } from "./ChucNang/InPhieu/BtnInPhieuThuChiNgoaiLe";
import { BtnSuaPhieuThuNgoaiLe } from "./ChucNang/Sua/BtnSuaPhieuThuNgoaiLe";
import { BtnSuaPhieuChiNgoaiLe } from "./ChucNang/Sua/BtnSuaPhieuChiNgoaiLe";

export const ContentTable = ({
  listQuanLyThuChiNgoaiLe,
  inPhieuThu,
  inPhieuChi,
  suaPhieu,
  xoaPhieu,
}) => {
  const dataSearch = useSelector(
    (state) => state.dataSearchQuanLyThuChiNgoaiLe
  );
  return listQuanLyThuChiNgoaiLe.map((item, index) => (
    <div className="custom-table-row" style={{ border: "none" }}>
      <div className="custom-table-cell-v2 username-cell flex-basis-5 flex-basis-5-sm disk-mobile ">
        <span className="mobile-column-name">STT</span>
        <div className="center-wrapper color7">
          <p className="text-center">
            {index + 1 + (dataSearch.pageIndex - 1) * dataSearch.pageSize}
          </p>
        </div>
      </div>

      <div className="custom-table-cell-v2 flex-basis-11 flex-basis-11-sm  center-flex">
        <span className="mobile-column-name">Ngày</span>
        <div className="center-wrapper color7">
          <p className="text-center">{getDate(item.Time)}</p>
        </div>
      </div>

      <div className="custom-table-cell-v2 flex-basis-12 flex-basis-12-sm center-flex">
        <span className="mobile-column-name">Mã phiếu</span>
        <div className="center-wrapper color7">
          <p className="text-center">
            <BtnChiTietPhieu item={item} />
          </p>
        </div>
      </div>

      <div className="custom-table-cell-v2 flex-basis-12 flex-basis-12-sm">
        <span className="mobile-column-name">Nhân viên</span>
        <div className="center-wrapper color7">
          <p className="text-left word-break">{item.userFullName}</p>
        </div>
      </div>

      <div className="custom-table-cell-v2 flex-basis-16 flex-basis-16-sm">
        <span className="mobile-column-name">Người nhận/ Người nộp tiền</span>
        <div className="center-wrapper color7">
          <p className="text-left word-break">{item.Name}</p>
        </div>
      </div>

      <div className="custom-table-cell-v2 flex-basis-11 flex-basis-11-sm">
        <span className="mobile-column-name">Loại phiếu</span>
        <div className="center-wrapper color7">
          <p className="text-center word-break">{item.TypeName}</p>
        </div>
      </div>

      <div className="custom-table-cell-v2 flex-basis-11 flex-basis-11-sm">
        <span className="mobile-column-name">Thu ngoài lề</span>
        <div className="center-wrapper">
          {item.Value > 0 ? (
            <p className="color-xanh-bold text-right">
              {formatNumber(item.Value)}
            </p>
          ) : (
            <p className="color-xanh-bold text-right">0</p>
          )}
        </div>
      </div>

      <div className="custom-table-cell-v2 flex-basis-11 flex-basis-11-sm">
        <span className="mobile-column-name">Chi ngoài lề</span>
        <div className="center-wrapper">
          {item.Value < 0 ? (
            <p className="color-do-bold text-right">
              {formatNumber(item.Value)}
            </p>
          ) : (
            <p className="color-do-bold text-right">0</p>
          )}
        </div>
      </div>

      <div className="custom-table-cell-v2 flex-basis-11 flex-basis-11-sm  action-cell">
        <div className="center-wrapper">
          <div className="iconTableMormanCenter">
            {suaPhieu && item.IsEdit == 1 && item.Value >= 0 && (
              <BtnSuaPhieuThuNgoaiLe item={item} />
            )}
            {suaPhieu && item.IsEdit == 1 && item.Value < 0 && (
              <BtnSuaPhieuChiNgoaiLe item={item} />
            )}
            {item.Value >= 0 && inPhieuThu && (
              <BtnInPhieuThuChiNgoaiLe item={item} inPhieuThu={inPhieuThu} />
            )}
            {item.Value < 0 && inPhieuChi && (
              <BtnInPhieuThuChiNgoaiLe item={item} inPhieuThu={inPhieuThu} />
            )}
            {xoaPhieu && item.IsDelete === 1 && <BtnXoa item={item} />}
          </div>
        </div>
      </div>
    </div>
  ));
};
